import { useEffect, useState } from "react";
import StepOne from "../Components/StepOne";
import StepTwo from "../Components/StepTwo";
import StepThree from "../Components/StepThree";
import StepFour from "../Components/StepFour";
import StepFive from "../Components/StepFive";
import ThankYou from "../Components/ThankYou";
import { useLocation } from "react-router-dom";

// const libraries = ["places"];

const Home = () => {
    const [step, setStep] = useState(1);
    const [origin, setOrigin] = useState(null);
    const [destination, setDestination] = useState(null);
    const [distance, setDistance] = useState(null);
    const [duration, setDuration] = useState(null);
    const [directions, setDirections] = useState(null);
    const [formValues, setFormValues] = useState({
        selectedVehicle: null,
        childSeatCount0_12: 0,
        childSeatCount1_4: 0,
        childSeatCount4_12: 0,
        childSeatAge: 6,
        childSeatSelected: false,
        flowersCount: 1,
        flowersSelected: false,
        champagneCount: 1,
        champagneSelected: false,
        weddingRibbonCount: 1,
        weddingRibbonSelected: false,
        serviceType: "",
        returnDateTime: "",
        returnDate: "",
        returnTime: "",
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: "",
        DateTime: "",
        FlightNumber: "",
        AirlineName: "",
        ArrivalTime: "",
        DepartureTime: "",
        Passengers: 1,
        Suitcases: 0,
        HandCarry: 0,
        NameBoard: "",
        // AnonymousName:"",
        AdditionalComments: "",
        CompanyName: "",
        BillingAddress: "",
        City: "",
        PostalCode: "",
        Country: "",
        type: "distance",
        hours: 3,
        toPay: "",
        sendDriverInside: "",
    });

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // const pickupLatitude = parseFloat(queryParams.get("pickupLatitude"));
    // const pickupLongitude = parseFloat(queryParams.get("pickupLongitude"));
    // const dropoffLatitude = parseFloat(queryParams.get("dropoffLatitude"));
    // const dropoffLongitude = parseFloat(queryParams.get("dropoffLongitude"));
    const pickUpPlaceId = queryParams.get("pickUpPlaceId");
    const dropOffPlaceId = queryParams.get("dropOffPlaceId");
    const pickupDate = queryParams.get("pickupdate");
    const pickupTime = queryParams.get("pickuptime");
    const transferType = queryParams.get("type");
    const transferHours = queryParams.get("hours");

    useEffect(() => {
        if (queryParams.size > 8) {
            setFormValues((prev) => ({
                ...prev,
                type: transferType ? transferType : "distance",
                Cal_Date: pickupDate ? new Date(pickupDate) : "",
                Cal_Time: pickupTime
                    ? new Date(`${pickupDate} ${pickupTime}`)
                    : "",
                pickUpDate: pickupDate
                    ? new Date(pickupDate).toDateString()
                    : "",
                pickUpTime: pickupTime
                    ? new Date(
                          `${pickupDate} ${pickupTime}`
                      ).toLocaleTimeString()
                    : "",
                [transferHours && "hours"]: transferHours,
            }));

            // If you already have the default latitude and longitude, then perform reverse geocoding.
            if (pickUpPlaceId) {
                const geocoder = new window.google.maps.Geocoder();
                geocoder.geocode(
                    { placeId: pickUpPlaceId },
                    (results, status) => {
                        console.log(results);
                        if (status === "OK" && results && results.length > 0) {
                            setOrigin(results[0]);
                        } else {
                            console.error("Geocoder failed:", status);
                        }
                    }
                );
            }
            if (dropOffPlaceId) {
                const geocoder = new window.google.maps.Geocoder();
                geocoder.geocode(
                    { placeId: dropOffPlaceId },
                    (results, status) => {
                        console.log("results", results);
                        if (status === "OK" && results && results.length > 0) {
                            setDestination(results[0]);
                        } else {
                            console.error("Geocoder failed:", status);
                        }
                    }
                );
            }
        }
    }, []);

    return (
        <div>
            {(() => {
                if (step === 1) {
                    return (
                        <StepOne
                            origin={origin}
                            setOrigin={setOrigin}
                            destination={destination}
                            setDestination={setDestination}
                            distance={distance}
                            setDistance={setDistance}
                            duration={duration}
                            setDuration={setDuration}
                            directions={directions}
                            setDirections={setDirections}
                            setStep={setStep}
                            formValues={formValues}
                            setFormValues={setFormValues}
                        />
                    );
                } else if (step === 2) {
                    return (
                        <StepTwo
                            setStep={setStep}
                            origin={origin}
                            destination={destination}
                            distance={distance}
                            formValues={formValues}
                            setFormValues={setFormValues}
                            duration={duration}
                            // DateTime={null}
                            setOrigin={setOrigin}
                            setDestination={setDestination}
                            setDistance={setDistance}
                            setDuration={setDuration}
                            directions={directions}
                            setDirections={setDirections}
                        />
                    );
                } else if (step === 3) {
                    return (
                        <StepThree
                            setStep={setStep}
                            formValues={formValues}
                            setFormValues={setFormValues}
                        />
                    );
                } else if (step === 4) {
                    return (
                        <StepFour
                            setStep={setStep}
                            formValues={formValues}
                            setFormValues={setFormValues}
                            origin={origin}
                            destination={destination}
                        />
                    );
                } else if (step === 5) {
                    return (
                        <StepFive
                            setStep={setStep}
                            formValues={formValues}
                            setFormValues={setFormValues}
                            distance={distance}
                            duration={duration}
                            origin={origin}
                            destination={destination}
                        />
                    );
                } else if (step === 6) {
                    return <ThankYou />;
                }
            })()}
        </div>
    );
};

export default Home;
